import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/oversize/`;

const registerOverSizeList = async (formData) => {
  return await axios.post(API_URL, formData);
};

const getOverSizeLists = async () => {
  return await axios.get(API_URL);
};

const deleteOverSizeList = async (id) => {
  return await axios.delete(API_URL + id);
};

export default {
  getOverSizeLists,
  registerOverSizeList,
  deleteOverSizeList,
};